export default __webpack_public_path__ + "static/media/slide2.49f84acb.png";